import QuestionnaireTemplateEditor from './QuestionnaireTemplateEditor';

export default QuestionnaireTemplateEditor;
